/**
 * Branch event names shared by the mobile Branch service.
 * Web never sends these; the mobile app registers the sink at startup.
 */
export const BRANCH_EVENTS = {
  REGISTRATION: 'registration',
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgot_password',
  AI_ASSISTANCE_ROBI: 'ai_assistance_robi',
  CHOOSE_AI_BUDDY: 'choose_ai_buddy',
  LOGOUT: 'logout',
} as const;

export type BranchEventName = (typeof BRANCH_EVENTS)[keyof typeof BRANCH_EVENTS];
